
export default function BrandCapitalSection() {
  return (
    <section className="py-16 sm:py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1F3B] mb-4 sm:mb-6">
            Brand Capital Italia
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-[#1C1C1C]/70 max-w-3xl mx-auto leading-relaxed px-4">
            Leader nella valutazione e valorizzazione del patrimonio aziendale con metodologie certificate e riconosciute a livello internazionale
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10 lg:gap-12">
          <div className="text-center">
            <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 sm:mb-6 flex items-center justify-center">
              <i className="ri-award-line text-5xl sm:text-6xl text-[#22C55E]"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-[#0B1F3B] mb-3 sm:mb-4">Certificazione ISO</h3>
            <p className="text-sm sm:text-base text-[#1C1C1C]/70 leading-relaxed px-2">
              Metodologia conforme agli standard internazionali ISO 10668 per la valutazione del brand
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 sm:mb-6 flex items-center justify-center">
              <i className="ri-line-chart-line text-5xl sm:text-6xl text-[#E879F9]"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-[#0B1F3B] mb-3 sm:mb-4">KPI Economici</h3>
            <p className="text-sm sm:text-base text-[#1C1C1C]/70 leading-relaxed px-2">
              Analisi approfondita degli indicatori chiave di performance per massimizzare il valore aziendale
            </p>
          </div>

          <div className="text-center md:col-span-2 lg:col-span-1">
            <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 sm:mb-6 flex items-center justify-center">
              <i className="ri-money-euro-circle-line text-5xl sm:text-6xl text-[#22C55E]"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-[#0B1F3B] mb-3 sm:mb-4">Valore Attivabile</h3>
            <p className="text-sm sm:text-base text-[#1C1C1C]/70 leading-relaxed px-2">
              Identificazione e attivazione del potenziale economico del brand nel patrimonio intangibile
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
